import { loadExternalTokens, PublicClientApplication } from '@azure/msal-browser';

// Plain (non-React) access to the single PublicClientApplication instance Msal.tsx constructs —
// needed by code outside the component tree (emptyApi.ts's prepareHeaders) that can't use the
// `useMsal()` hook, the same way Firebase's `getApps()` gives non-React code access to its app
// singleton.
let instance: PublicClientApplication | undefined;

export function setMsalInstance(pca: PublicClientApplication) {
    instance = pca;
}

export function getMsalInstance(): PublicClientApplication | undefined {
    return instance;
}

// Exposes msal-browser's loadExternalTokens and this module's instance getter for Playwright's
// page.evaluate() to reach — injected scripts run in the page's global context and can't `import`
// app modules. E2E tests hydrate the MSAL cache with a token obtained out-of-band (ROPC) instead
// of driving the interactive Microsoft sign-in form, per MSAL's own documented testing pattern
// (specs/001-msal-login/research.md Decision 6). getMsalInstance is needed so the test can call
// setActiveAccount() after injection — loadExternalTokens populates the cache but never marks an
// account active, so without this the app's later acquireTokenSilent calls (emptyApi.ts's
// prepareHeaders) can't find the session.
declare global {
    interface Window {
        __msalTestHelpers?: {
            loadExternalTokens: typeof loadExternalTokens;
            getMsalInstance: typeof getMsalInstance;
        };
    }
}
window.__msalTestHelpers = { loadExternalTokens, getMsalInstance };
